export default "__VITE_ASSET__f0a9dafa__"